import { Guid } from '@ups/xplat/core';
import { Manufacturer } from './manufacturer';
import { Tethering } from './tethering';

export class ManufacturerItem {
  manufacturerItemId: string;
  itemId: string;
  manufacturerPartNumber: string;
  manufacturer: Manufacturer;
  tetheringData: Tethering;
  unitOfMeasure: string;

  constructor() {
    this.manufacturerItemId = Guid.empty;
    this.manufacturer = new Manufacturer();
    this.tetheringData = new Tethering();
  }
}
